export const getViewedUserSiteMemberId = (state) => state.viewedUser;
